import { Divider } from './components/divider'
import { Footer } from './components/footer'
import type { OptionMenuProps } from './option-menu.types'

import { type Scope, createContextScope } from '@radix-ui/react-context'
import React from 'react'
import { Group } from './components/group'
import { Item } from './components/item'
import { List } from './components/list'

type OptionMenuContext = Pick<OptionMenuProps, 'type'>

const DISPLAY_NAME = 'OptionMenu'

const Root = (props: OptionMenuProps) => {
  const {
    type,
    children,
    customEmptyMessage = 'Não foi encontrado nenhum resultado.',
    testID,
    __scopeOptionMenu,
  } = props as ScopedProps<OptionMenuProps>

  const renderChildren = React.Children.map(children, child => {
    if (
      React.isValidElement(child) &&
      (child.type === List || child.type === Footer)
    ) {
      return child
    }
  })

  return (
    <OptionMenuProvider
      scope={__scopeOptionMenu}
      type={type}
      data-testid={testID}
    >
      <div className="rounded-form border-border-neutral border-quarterpulse bg-fill-neutral py-onepulse">
        {React.Children.count(children) > 0 ? (
          <div className="flex-grow">{renderChildren}</div>
        ) : (
          <div className="flex items-start justify-center">
            <p className="tracking px-onepulse py-twopulse font-regular text-rdmodern text-text-neutral text-threeandhalfpulse leading-small">
              {customEmptyMessage}
            </p>
          </div>
        )}
      </div>
    </OptionMenuProvider>
  )
}

/*
----------------------------------------------------------------
Scope Definition
----------------------------------------------------------------
*/

export type ScopedProps<P> = P & {
  __scopeOptionMenu?: Scope
}

const [createOptionMenuContext] = createContextScope(DISPLAY_NAME)

export const [OptionMenuProvider, useOptionMenuContext]: readonly [
  ProviderType<OptionMenuContext>,
  (consumerName: string, scope: Scope) => OptionMenuContext,
] = createOptionMenuContext<OptionMenuContext>(DISPLAY_NAME)

/*
----------------------------------------------------------------
Composition Export
----------------------------------------------------------------
*/

export const OptionMenu = {
  Root,
  Footer,
  Divider,
  Item,
  List,
  Group,
}
